import React, {useRef, useEffect, useState} from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';

const BfFormstep13 = ({lang, setLang, nextStep, backStep, updateFormData, formData, setRecaptchaValue }) => {
  const [fileStatus, setFileStatus] = useState({});
  
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  //create a state variable called showerrormaxfiles starts as false
  const [showerrormaxfiles, setshowerrormaxfiles] = React.useState(false);
  //create a state vatiabel called showerrormaxsize starts as false
  const [showerrormaxsize, setshowerrormaxsize] = React.useState(false);
  const uploadFiles = async (files) => {
    if (!Array.isArray(files) || files.length === 0) {
      throw new Error('Invalid input: files should be a non-empty array.');
    }
  
    const uploadPromises = files.map(async (file) => {
      const formData = new FormData();
      formData.append('file', file);
  
      try {
        const response = await fetch('https://stg-zodiac.confielms.com/api/files/uploads/blf-buses/save/v1', {
          method: 'POST',
          body: formData
        });
  
        // Check if the response is JSON
        if (response.headers.get('content-type') && response.headers.get('content-type').includes('application/json')) {
          const result = await response.json();
          return result.url;
        } else {
          console.warn('Uploaded file did not return a JSON response:', response);
          return "error"; // Ignore this file and continue with the next one
        }
      } catch (error) {
        console.error('Error uploading file:', error);
        // Log the error and proceed to the next file
        return "error";
      }
    });
  
    try {
      // Wait for all uploadPromises to complete
      const uploadedUrls = await Promise.all(uploadPromises);
      // Filter out any undefined URLs (files that did not return a JSON response)
      const filteredUrls = uploadedUrls.filter(url => url !== undefined);
      return filteredUrls;
    } catch (error) {
      // Handle any error that occurred during file uploads
      throw error;
    }
  };
  

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js?render=6LfiPNIUAAAAAMRc-uxUCze2sMZnwcaKPrR95mwz';
    script.addEventListener('load', () => {
      window.grecaptcha.ready(async () => {
        const response = await window.grecaptcha.execute('6LfiPNIUAAAAAMRc-uxUCze2sMZnwcaKPrR95mwz', { action: 'submit' });
        setRecaptchaValue(response);
      });
    });
    document.body.appendChild(script);

    // Add styles to hide reCAPTCHA badge
    const style = document.createElement('style');
    style.innerHTML = '.grecaptcha-badge { display: none; }';
    document.head.appendChild(style);
  }, [setRecaptchaValue]);
  const formik = useFormik({
    initialValues: {
      fileInput: [], // Add fileInput field to store selected files
    },
    validationSchema: Yup.object().shape({
      fileInput: Yup.array()
        .max(5, 'You can upload up to 5 files')
        .test(
          'fileFormat',
          'Unsupported file format. Supported formats: JPEG, PNG, PDF, Word',
          (value) => {
            if (!value || value.length === 0) return true; // Allow empty field
            const supportedFormats = [
              'image/jpeg',
          
              'image/png',
              'application/pdf',
              'application/msword',
              'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // For .docx
              'application/vnd.ms-excel', // For .xls
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' // For .xlsx
            ];
            
            return value.every((file) => supportedFormats.includes(file.type));
          }
        ),
    }),
    onSubmit: async (values) => {
      setIsSubmitting(true);
      try {
        const files = values.fileInput;
        if (!Array.isArray(files) || files.length === 0) {
          nextStep();
          return;
        }
  
        const uploadedUrls = await uploadFiles(files);
  
        const updatedFormValues = { files: [] };
  
        const updatedFileStatus = {};
  
        uploadedUrls.forEach((url, index) => {
          if (url !== "error") {
            updatedFormValues.files.push(url);
            updatedFileStatus[index] = { status: 'success', url };
          } else {
            updatedFileStatus[index] = { status: 'error' };
          }
        });
        console.log('updated file status', updatedFileStatus)
        setFileStatus(updatedFileStatus);
  
        updateFormData(updatedFormValues);
  //wait 10 seconds
        setTimeout(() => { 
         nextStep();
          }
          , 10000);
      
      } catch (error) {
        console.error('Error during file upload:', error);
        // Handle error as needed, e.g., show an error message to the user
      }
    }
    
    
    
    
  });


  return (


    <>
      <header className="c-site-header">
        <a className="c-site-header__skip js-site-header-skip" href="#main">
          Skip to main content
        </a>
        <div className="o-wrapper">
          <a
            className="c-site-header__logo-link"
            href="./"
            aria-label="Go to home page"
          >
            <img
              className="c-site-header__logo"
              src="images/components/site-header/logo-blf-specialty.svg"
              alt="Bluefire Specialty Logo"
              width={100}
              height={34}
            />
          </a>
          <h1 className="c-site-header__title">
            <span className="o-icon">
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="4166848_data_doc_docs_documents_file_icon 1">
<path id="Vector" d="M25.8231 2.15991H9.06151L7.92031 3.30111V5.75991H5.46151L4.32031 6.90111V32.6987L5.46151 33.8399H26.9391L28.0803 32.6987V30.2399H30.5391L31.6803 29.0987V8.01711L25.8231 2.15991ZM30.2403 8.61111V8.63991H25.4991L25.2003 8.34111V3.59991H25.2291L30.2403 8.61111ZM26.6403 32.1011L26.3415 32.3999H6.05911L5.76031 32.1011V7.49871L6.05911 7.19991H7.92031V29.0987L9.06151 30.2399H26.6403V32.1011ZM29.9415 28.7999H9.65911L9.36031 28.5011V3.89871L9.65911 3.59991H23.7603V8.93871L24.9015 10.0799H30.2403V28.5011L29.9415 28.7999Z" fill="#0085FF"/>
<path id="Vector_2" d="M28.0795 25.2H11.5195V26.64H28.0795V25.2Z" fill="#0085FF"/>
</g>
</svg>

            </span>
            {lang === 'eng' ? 'Documents' : 'Documentos'}
          </h1>
          <div className="c-site-header__controls c-header-controls">
          <button 
    className="c-header-controls__language" 
    onClick={() => setLang(lang === 'eng' ? 'spa' : 'eng')}  // Toggle the language
  >
    <span className="o-icon c-header-controls__icon">
      <svg aria-hidden="true" focusable="false" role="img">
        <use href="images/icons/icons.svg#icon-language" />
      </svg>
    </span>
    <span className="u-hidden-visually">
      {lang === 'eng' ? 'Switch to Spanish' : 'Switch to English'}
    </span>
    <span className="c-header-controls__text">
      {lang === 'eng' ? 'Español' : 'English'}
    </span>
  </button>
          </div>
        </div>
      </header>
      <main className="c-main-content">
        <div className="c-section">
          <div className="o-wrapper o-wrapper--small">
            <h1 className="c-section__title">
              <span className="o-icon">
              <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="4166848_data_doc_docs_documents_file_icon 1">
<path id="Vector" d="M25.8231 2.15991H9.06151L7.92031 3.30111V5.75991H5.46151L4.32031 6.90111V32.6987L5.46151 33.8399H26.9391L28.0803 32.6987V30.2399H30.5391L31.6803 29.0987V8.01711L25.8231 2.15991ZM30.2403 8.61111V8.63991H25.4991L25.2003 8.34111V3.59991H25.2291L30.2403 8.61111ZM26.6403 32.1011L26.3415 32.3999H6.05911L5.76031 32.1011V7.49871L6.05911 7.19991H7.92031V29.0987L9.06151 30.2399H26.6403V32.1011ZM29.9415 28.7999H9.65911L9.36031 28.5011V3.89871L9.65911 3.59991H23.7603V8.93871L24.9015 10.0799H30.2403V28.5011L29.9415 28.7999Z" fill="#0085FF"/>
<path id="Vector_2" d="M28.0795 25.2H11.5195V26.64H28.0795V25.2Z" fill="#0085FF"/>
</g>
</svg>

              </span>
              {lang === 'eng' ? 'Documents' : 'Documentos'}
            </h1>
            <div className="c-section__content">
              <div className="c-steps">
                <ul className="o-list-bare c-steps__list">
                  <li className="o-list-bare__item c-steps__item c-steps__item--100 c-steps__step--completed ">
                    <div className="c-steps__step">
                    <div className="c-steps__text">{lang === 'eng' ? 'Applicant' : 'Solicitante'}</div>
                      <div className="c-steps__circle" />
                    </div>
                  </li>
                  <li className="o-list-bare__item c-steps__item c-steps__step--completed c-steps__item--100  ">
                    <div className="c-steps__step c-steps__step">
                    <div className="c-steps__text">{lang === 'eng' ? 'Drivers' : 'Conductores'} </div>
                      <div className="c-steps__circle" />
                    </div>
                  </li>
                  <li className="o-list-bare__item c-steps__item  c-steps__step--completed c-steps__item--100 ">
                    <div className="c-steps__step c-steps__step">
                    <div className="c-steps__text">{lang === 'eng' ? 'Vehicles' : 'Vehículos'}</div>
                      <div className="c-steps__circle" />
                    </div>
                  </li>
                  <li className="o-list-bare__item c-steps__item c-steps__item--50 c-steps__step--active">
                <div className="c-steps__step">
                  <div className="c-steps__text">{lang === 'eng' ? 'Documents' : 'Documentos' }</div>
                  <div className="c-steps__circle" />
                </div>
              </li>
                  
                  <li className="o-list-bare__item c-steps__item">
                    <div className="c-steps__step">
                    <div className="c-steps__text">{lang === 'eng' ? 'Finish' : 'Finalizar' }</div>
                      <div className="c-steps__circle" />
                    </div>
                  </li>
                </ul>
              </div>
              {isSubmitting &&
              <div className="c-content">
       
              <div className="c-files">
                <div className="c-files__title">{lang === 'eng' ? 'Uploading Files -' : 'Subiendo Archivos -'} {formik.values.fileInput.length || 0} {lang === 'eng' ? 'files' : 'archivos'}</div>
                <ul className="o-list-bare c-files-list">
                   {formik.values.fileInput.map((file, index) => (
        <div key={index}>
          {/* Display the file name */}
          <span>{file.name}</span>

          {/* Display the file status */}
          {fileStatus[index] && fileStatus[index].status === 'success' && (<>
            <span style={{ color: 'green' }}>    -     </span>
            <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      x="0"
      y="0"
      viewBox="0 0 48 48"
    >
      <path
        fill="#c8e6c9"
        d="M44 24c0 11.045-8.955 20-20 20S4 35.045 4 24 12.955 4 24 4s20 8.955 20 20z"
      ></path>
      <path
        fill="#4caf50"
        d="M34.586 14.586l-13.57 13.586-5.602-5.586-2.828 2.828 8.434 8.414 16.395-16.414-2.829-2.828z"
      ></path>
    </svg>
            </>
          )}
          {fileStatus[index] && fileStatus[index].status === 'error' && (
            <>
            <span style={{ color: 'red' }}> - </span>
            <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      x="0"
      y="0"
      viewBox="0 0 48 48"
    >
      <path
        fill="#F44336"
        d="M36.021 8.444l3.536 3.536L11.98 39.557 8.443 36.02z"
      ></path>
      <path
        fill="#F44336"
        d="M39.555 36.023l-3.536 3.535L8.445 11.976l3.536-3.535z"
      ></path>
    </svg>
            </>
          )}

          <br />
  
        </div>
      ))}
                </ul>
                {  formik.values.fileInput.length === 5 && showerrormaxfiles ? (
    <label id="radius_operation-error" className="js-form-error" htmlFor="radius_operation">
      {lang === 'eng' ? 'You can only upload up to 5 files' : 'Solo puedes subir hasta 5 archivos'}
    </label>
                ) : null}
                {  showerrormaxsize ? (
    <label id="radius_operation-error" className="js-form-error" htmlFor="radius_operation">
      {lang === 'eng' ? 'You can upload files up to 3mb in size' : 'Puedes subir archivos de hasta 3mb de tamaño'}
    </label>
                ) : null}
              </div>
              </div>
              }







              {!isSubmitting &&
              <div className="c-content">
                <div className="c-quote">
                  <form onSubmit={formik.handleSubmit} className="c-quote__form js-form" noValidate>
                

                    <h2 className="c-quote__title">
                    {lang === 'eng' ? 'Upload your files' : 'Sube tus documentos'}
                    </h2>
                    <div className="s-cms-content">
                      <p>{lang === 'eng' ? 'Please provide a copy of the following documents:' : 'Por favor, envíanos una copia de los siguientes documentos:' }</p>
                      <ul>
                        <li>
                        {lang === 'eng' ? 
                          '5-year loss run report or the years crossing into the USA. Information must not be older than 45 days from requested.' : 'Reporte de pérdidas de los últimos 5 años, o los años en los que hayas cruzado hacia los Estados Unidos. La información no debe tener más de 45 días desde la solicitud.'
                        }
                        </li>
                        <li>{lang === 'eng' ? 'Copy of driver\'s license from all drivers.' : 'Copia de la licencia de conducir de todos los conductores.' }</li>
                        <li>{lang === 'eng' ? 'Vehicle Registration for all listed vehicles.' : 'Registro de los vehículos mencionados'}</li>
                      </ul>
                    </div>
                    <div className="c-upload">
                      <label className="c-upload__label">
                        <span className="o-icon c-upload__icon">
                          <svg aria-hidden="true" focusable="false" role="img">
                            <use href="images/icons/icons.svg#icon-upload" />
                          </svg>
                        </span>
                        {lang === 'eng' ? ' Drop files or ' : 'Arrastra los archivos aquí o '} <span>{lang === 'eng' ? 'Browse' : 'búscalos' }</span>
                        <div className="c-upload__label-text">
                          {lang === 'eng'? 'Supported formats: JPEG, PNG, PDF, Word, Excel' : 'Formatos admitidos: JPEG, PNG, PDF, Word, Excel'}
                        </div>
                        <input
                          className="c-upload__input"
                          type="file"
                          multiple
                          accept=".jpeg,.jpg,.png,.pdf,.doc,.docx,.xls,.xlsx"
                          //disable if the fileInput length is 5
                          onDragOver={(event) => {
                              event.preventDefault();
                              // Add any additional styles or visual indicators for drag over if needed
                            }}
                            onDrop={(event) => {
  event.preventDefault();
  setshowerrormaxsize(false);

  if (formik.values.fileInput.length === 5) {
    setshowerrormaxfiles(true);
  } else {
    const droppedFiles = event.dataTransfer.files;

    // Check file types for each dropped file
    const allowedFileTypes = [".jpeg", ".jpg", ".png", ".pdf", ".doc", ".docx", ".xls", ".xlsx"];
    const isValidFileType = Array.from(droppedFiles).every(file => {
      const fileType = `.${file.name.split('.').pop()}`;
      return allowedFileTypes.includes(fileType.toLowerCase());
    });

    if (!isValidFileType) {
      // Display an error message or take appropriate action for invalid file type
      console.log("Invalid file type");
      return;
    }

    // Check file size for each dropped file
    const isFileSizeValid = Array.from(droppedFiles).every(file => file.size <= 4000000);

    if (!isFileSizeValid) {
      // Display an error message or take appropriate action for files exceeding 5MB
      console.log("File size exceeds 5MB");
      setshowerrormaxsize(true);
      return;
    }

    // Handle file input changes here
    const updatedFiles = [...formik.values.fileInput, ...droppedFiles].slice(0, 5);
    formik.setFieldValue('fileInput', updatedFiles);
    event.target.value = null;
  }
}}

                          onChange={(event) => {
                            setshowerrormaxsize(false);
                            if(formik.values.fileInput.length === 5){
                              setshowerrormaxfiles(true);
                            }else{
                            
                            //check if the file size is greater than 3mb
                            if(event.currentTarget.files[0].size > 4000000){
                              setshowerrormaxsize(true);
                          
                            }else{
                            // Handle file input changes here
                            const selectedFiles = Array.from(event.currentTarget.files);
                            const updatedFiles = [...formik.values.fileInput, ...selectedFiles].slice(0, 5);
                            formik.setFieldValue('fileInput', updatedFiles);
                            event.target.value = null;
                 
                            }
                            }
                          }}
                        />
                      </label>
                      <div className="c-files">
                        <div className="c-files__title">{lang === 'eng' ? 'Selected files -' : 'Archivos seleccionados -'} {formik.values.fileInput.length || 0} {lang === 'eng' ? 'files' : 'archivos'}</div>
                        <ul className="o-list-bare c-files-list">
                          {formik.values.fileInput.map((file, index) => (
                            <li key={index} className="o-list-bare__item c-files-list__item">
                              {file.name}{' '}
                              <button
                                className="c-files-list__btn-delete"
                                type="button"
                                onClick={() => {
                                  // Handle file removal here
                                  const updatedFiles = [...formik.values.fileInput];
                                  updatedFiles.splice(index, 1);
                                  formik.setFieldValue('fileInput', updatedFiles);
                           
                                }}
                              >
                                <span className="o-icon c-files-list__icon">
                                  <svg aria-hidden="true" focusable="false" role="img">
                                    <use href="images/icons/icons.svg#icon-delete" />
                                  </svg>
                                </span>
                              </button>
                            </li>
                          ))}
                        </ul>
                        {  formik.values.fileInput.length === 5 && showerrormaxfiles ? (
    <label id="radius_operation-error" className="js-form-error" htmlFor="radius_operation">
      {lang === 'eng' ? 'You can only upload up to 5 files' : 'Solo puedes subir hasta 5 archivos'}
    </label>
  
  ) : null}

  {  showerrormaxsize ? (
    <label id="radius_operation-error" className="js-form-error" htmlFor="radius_operation">
      {lang === 'eng' ? 'You can upload files up to 4mb in size' : 'Puedes subir archivos de hasta 4mb de tamaño'}
    </label>
  
  ) : null}
                      </div>
                    </div>
                    <div className="c-quote__controls">
                      <button
                        className="c-quote__control c-quote__control--previous c-button c-button--linear-indingo"
                        type="button"
                        onClick={backStep}
                      >
                        {lang === 'eng' ? 'Previous' : 'Atrás'}
                      </button>
                      <button
                        className="c-quote__control c-quote__control--submit c-button c-button--blue-light"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (lang === 'eng' ? "Processing" : "Procesando") : (lang === 'eng' ? 'Finalize' : 'Finalizar')}


                        {isSubmitting && (
                      <div className="c-loading js-loading">
                      <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        margin: "auto",
        background: "none",
      }}
      width="24px"
      height="24px"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
      display="block"
   
    >
      <rect x={47} y={24} rx={3} ry={6} width={6} height={12}fill="#fff">
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="1s"
          begin="-0.9166666666666666s"
          repeatCount="indefinite"
        />
      </rect>
      <rect
        x={47}
        y={24}
        rx={3}
        ry={6}
        width={6}
        height={12}
        fill="#fff"
        transform="rotate(30 50 50)"
      >
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="1s"
          begin="-0.8333333333333334s"
          repeatCount="indefinite"
        />
      </rect>
      <rect
        x={47}
        y={24}
        rx={3}
        ry={6}
        width={6}
        height={12}
       fill="#fff"
        transform="rotate(60 50 50)"
      >
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="1s"
          begin="-0.75s"
          repeatCount="indefinite"
        />
      </rect>
      <rect
        x={47}
        y={24}
        rx={3}
        ry={6}
        width={6}
        height={12}
       fill="#fff"
        transform="rotate(90 50 50)"
      >
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="1s"
          begin="-0.6666666666666666s"
          repeatCount="indefinite"
        />
      </rect>
      <rect
        x={47}
        y={24}
        rx={3}
        ry={6}
        width={6}
        height={12}
       fill="#fff"
        transform="rotate(120 50 50)"
      >
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="1s"
          begin="-0.5833333333333334s"
          repeatCount="indefinite"
        />
      </rect>
      <rect
        x={47}
        y={24}
        rx={3}
        ry={6}
        width={6}
        height={12}
       fill="#fff"
        transform="rotate(150 50 50)"
      >
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="1s"
          begin="-0.5s"
          repeatCount="indefinite"
        />
      </rect>
      <rect
        x={47}
        y={24}
        rx={3}
        ry={6}
        width={6}
        height={12}
       fill="#fff"
        transform="rotate(180 50 50)"
      >
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="1s"
          begin="-0.4166666666666667s"
          repeatCount="indefinite"
        />
      </rect>
      <rect
        x={47}
        y={24}
        rx={3}
        ry={6}
        width={6}
        height={12}
       fill="#fff"
        transform="rotate(210 50 50)"
      >
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="1s"
          begin="-0.3333333333333333s"
          repeatCount="indefinite"
        />
      </rect>
      <rect
        x={47}
        y={24}
        rx={3}
        ry={6}
        width={6}
        height={12}
       fill="#fff"
        transform="rotate(240 50 50)"
      >
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="1s"
          begin="-0.25s"
          repeatCount="indefinite"
        />
      </rect>
      <rect
        x={47}
        y={24}
        rx={3}
        ry={6}
        width={6}
        height={12}
       fill="#fff"
        transform="rotate(270 50 50)"
      >
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="1s"
          begin="-0.16666666666666666s"
          repeatCount="indefinite"
        />
      </rect>
      <rect
        x={47}
        y={24}
        rx={3}
        ry={6}
        width={6}
        height={12}
       fill="#fff"
        transform="rotate(300 50 50)"
      >
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="1s"
          begin="-0.08333333333333333s"
          repeatCount="indefinite"
        />
      </rect>
      <rect
        x={47}
        y={24}
        rx={3}
        ry={6}
        width={6}
        height={12}
       fill="#fff"
        transform="rotate(330 50 50)"
      >
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="1s"
          begin="0s"
          repeatCount="indefinite"
        />
      </rect>
    </svg>
</div> ) }
                      </button>
                   

                    </div>
                  </form>
                </div>
              </div>
              }
            </div>
          </div>
        </div>
      </main>

      <footer className="c-site-footer">
    <div className="o-wrapper">
      <div className="c-site-footer__legal">
        <p className="c-site-footer__legal_text">
          © 2023 Bluefire Insurance Services Inc.
          <br />
          {lang === 'eng' ? <>List Of Entity/License Numbers Per State Located On  <br/></> : <>Listado de entidades/números de licencia por estado <br /> localizada en nuestra página de</>}  
  <a href="https://www.bluefireinsurance.com/affiliate-disclosure/" target="_blank" rel="noopener noreferrer">
    {lang === 'eng'? "Affiliate Disclosure Page." : " Aviso de Nuestras Filiales"} 
  </a>

        </p>
          <ul className="o-list-bare c-site-footer__legal_links">
  <li className="o-list-bare__item c-site-footer__legal-link">
    <a href="https://www.bluefireinsurance.com/privacy-policy/" target="_blank" rel="noopener noreferrer">
      { lang=== 'eng' ? ` Privacy Policy` : `Políticas de privacidad`}
    </a>
  </li>
  {window.innerWidth <= 768 && lang !== 'eng' ? (
    <>
      <li className="o-list-bare__item c-site-footer__legal-link">
        <a href="https://www.bluefireinsurance.com/california-consumer-privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ whiteSpace: 'normal' }}>
          {lang === 'eng' ? "California Consumer Privacy Policy" : "Política de Privacidad del"}
        </a>
      </li>
      <li className="o-list-bare__item c-site-footer__legal-link spanish-consumer-link">
        <a href="https://www.bluefireinsurance.com/california-consumer-privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ whiteSpace: 'normal' }}>
          {lang === 'eng' ? "" : "Consumidor de California"}
        </a>
      </li>
    </>
  ) : (
    <li className="o-list-bare__item c-site-footer__legal-link ">
      <a href="https://www.bluefireinsurance.com/california-consumer-privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ whiteSpace: 'normal' }}>
        {lang === 'eng' ? "California Consumer Privacy Policy" : "Política de Privacidad del Consumidor de California"}
      </a>
    </li>
  )}
  <li className="o-list-bare__item c-site-footer__legal-link">
    <a href="https://www.bluefireinsurance.com/terms-of-use/" target="_blank" rel="noopener noreferrer">
      {lang === 'eng' ? " Terms of Use" : "Condiciones de uso"}
    </a>
  </li>
</ul>
      </div>
    </div>
  </footer>
    </>


  )
}

export default BfFormstep13;
